/**
 * BNZ Sticky Titles - Menu de navigation sticky inspiré Bremont
 * N'apparaît qu'une fois main-product scrollé (sorti du viewport)
 * En position "above_add_to_cart" : quand la sticky bar est masquée, positionne au-dessus du lecteur vinyle
 */

(function () {
  function initBnzStickyTitles() {
    const nav = document.querySelector('[data-bnz-sticky-titles]');
    const mainProduct = document.querySelector('.main-product');

    if (!nav || !mainProduct) {
      return;
    }

    const scrollSpyEnabled = nav.dataset.scrollSpy === 'true';
    const positionMode = nav.dataset.position || 'under_header';
    const links = nav.querySelectorAll('.bnz-sticky-titles__link');

    function getHeaderHeight() {
      const header = document.querySelector('header');
      return header ? header.offsetHeight : 0;
    }

    function syncHeaderHeight() {
      const headerHeight = getHeaderHeight();
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function isAddToCartBarVisible() {
      const stickyBar = document.getElementById('bnz-sticky');
      return stickyBar && stickyBar.classList.contains('visible');
    }

    function updateVisibility() {
      const headerHeight = getHeaderHeight();
      syncHeaderHeight();

      let shouldShow = false;

      if (positionMode === 'above_add_to_cart') {
        // Synchroniser avec la barre Add to Cart : n'afficher que quand elle est visible
        // Évite l'état intermédiaire où la title bar overlap la sticky pendant le scroll
        shouldShow = isAddToCartBarVisible();
      } else {
        // Position sous le header : afficher quand le bas de main-product est sorti du viewport
        const rect = mainProduct.getBoundingClientRect();
        const mainProductBottom = rect.bottom;
        const threshold = headerHeight;
        shouldShow = mainProductBottom < threshold;
      }

      if (shouldShow) {
        nav.classList.remove('bnz-sticky-titles--hidden');
        nav.classList.add('bnz-sticky-titles--visible');
        if (positionMode === 'above_add_to_cart') {
          nav.classList.remove('bnz-sticky-titles--sticky-bar-hidden');
          // Expose height so the sticky pill can stack above
          document.documentElement.style.setProperty('--bnz-sticky-titles-height', nav.offsetHeight + 'px');
        }
      } else {
        nav.classList.add('bnz-sticky-titles--hidden');
        nav.classList.remove('bnz-sticky-titles--visible');
        if (positionMode === 'above_add_to_cart') {
          nav.classList.add('bnz-sticky-titles--sticky-bar-hidden');
          document.documentElement.style.setProperty('--bnz-sticky-titles-height', '0px');
        }
      }
    }

    function updateScrollSpy() {
      if (!scrollSpyEnabled || links.length === 0) return;

      const headerHeight = getHeaderHeight();
      const scrollPosition = window.scrollY + headerHeight + 50;

      let activeLink = null;

      links.forEach((link) => {
        const targetId = link.getAttribute('data-target-id');
        if (!targetId) return;

        const target = document.getElementById(targetId);
        if (!target) return;

        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const targetBottom = targetTop + target.offsetHeight;

        if (scrollPosition >= targetTop && scrollPosition < targetBottom) {
          activeLink = link;
        }
      });

      links.forEach((link) => {
        link.classList.toggle('is-active', link === activeLink);
      });
    }

    function handleLinkClick(e) {
      const link = e.currentTarget;
      const targetId = link.getAttribute('data-target-id');
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Event listeners
    links.forEach((link) => {
      link.addEventListener('click', handleLinkClick);
    });

    let ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateVisibility();
          updateScrollSpy();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      syncHeaderHeight();
      updateVisibility();
      updateScrollSpy();
    });

    // Initial: s'assurer que --header-height est défini (pour le positionnement CSS)
    syncHeaderHeight();
    updateVisibility();
    updateScrollSpy();

    // Sur mobile: recalcul après chargement des images (layout peut changer)
    if (isMobile()) {
      window.addEventListener('load', () => {
        syncHeaderHeight();
        updateVisibility();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBnzStickyTitles);
  } else {
    initBnzStickyTitles();
  }
})();
